<output-form-row [labelId]="'device_info.type'" [value]="type()"></output-form-row>
<output-form-row [labelId]="'device_info.device_id'" [value]="deviceId()"></output-form-row>
<output-form-row [labelId]="'device_info.model'" [value]="model()"></output-form-row>
<output-form-row [labelId]="'device_info.operation_system'" [value]="operationSystem()"></output-form-row>
